module.exports = __webpack_public_path__ + "static/media/edzil.22375066.jpg";